import { createMuiTheme, ThemeOptions } from '@material-ui/core';

export const SaurusThemeOptions: ThemeOptions = {
  palette: {
    primary: {
      main: '#0E72AC',
      light: '#57a0de',
      dark: '#00477c',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#999999',
      light: '#cacaca',
      dark: '#6b6b6b',
      contrastText: '#555',
    },
    text: {
      primary: 'rgba(61, 61, 61, 1)'
    }
  },
  props: {
    MuiTextField: {
      variant: 'outlined',
      autoComplete: 'off',
      fullWidth: true,
    },
    MuiButton: {
      variant: 'contained',
      style: {
        cursor: 'pointer',
      },
      disableElevation: true,
      color: 'primary',
      fullWidth: false,
    },
  },
  overrides: {
    MuiButton: {
      root: {
        textTransform: 'none',
        padding: '10px 22px',
        fontSize: '0.90rem',
      },
      sizeSmall: {
        padding: '8px 20px',
        fontSize: '0.90rem',
      },
      sizeLarge: {
        padding: '14px 28px',
        fontSize: '0.95rem',
      },
      outlined: {
        padding: '10px 22px',
        fontSize: '0.90rem',
      }
    },
  },
  shape: {
    borderRadius: 12,
  },
};

export const SaurusTheme = createMuiTheme(SaurusThemeOptions);

// Ajuste de autofill dependente do palette (claro/escuro)
SaurusTheme.overrides = {
  ...SaurusTheme.overrides,
  MuiInputBase: {
    input: {
      '&:-webkit-autofill': {
        WebkitTextFillColor: SaurusTheme.palette.text.primary,
        caretColor: SaurusTheme.palette.text.primary,
        WebkitBoxShadow: `0 0 0 1000px ${SaurusTheme.palette.background.paper} inset`,
        transition: 'background-color 9999s ease 0s',
      },
      '&:-webkit-autofill:focus': {
        WebkitTextFillColor: SaurusTheme.palette.text.primary,
        caretColor: SaurusTheme.palette.text.primary,
        WebkitBoxShadow: `0 0 0 1000px ${SaurusTheme.palette.background.paper} inset`,
      },
      '&:-moz-autofill': {
        color: SaurusTheme.palette.text.primary,
        backgroundColor: `${SaurusTheme.palette.background.paper} !important`,
      },
    },
  },
};
